exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-image-wrapper{display:inline-block;position:relative;overflow:hidden;width:100%;height:100%;background:transparent}", ""]);

// exports
